import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import { Col, Row, Card, CardHeader, CardBody, Button, Dropdown, DropdownItem, DropdownMenu, ButtonGroup, Input, Label, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { FLASH } from "../../helpers/data_helper";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import {getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
    currencyFormatWithoutDecimalV1
} from "../../helpers/api_helper";
import {
    getKIPWidgetData,
  } from "../../store/actions";
import LocationChartCovers from "./LocationChartCovers";
import LocationChartRevenue from "./LocationChartRevenue";

const LocationWidget = ({ rightFilter, comparisonDate, leftFilter, mealPeriod, refresh, leftCustomDate }) => {
    const userOutletDetails = getLocalStorageData('userOutletDetails');
    const currency=userOutletDetails?.currency??"$";
    const dispatch = useDispatch();

    const [showFull, setShowFull] = useState(false);
    const [isLocationDetailOpen, setIsLocationDetailOpen] = useState(false);
    const toggleLocationDetails = () => setIsLocationDetailOpen(!isLocationDetailOpen);
    const [selectedSection, setSelectedSection] = useState(null);

    let rightFilterLabel = (rightFilter && rightFilter.value!=="Custom") ? rightFilter.label : "";
    if (rightFilter && rightFilter.value==="ThisMonth") {
        rightFilterLabel = "Month-to-date";
    } else if (rightFilter && rightFilter.value==="Custom" && comparisonDate.length > 0) {
        rightFilterLabel = displayDateV1(comparisonDate);
    }

     const {
        widgetData,
        widgetAjax,
      } = useSelector((state) => ({
        widgetData: state.Dashboard.widgetData,
        widgetAjax: state.Dashboard.widgetAjax
      }));

    useEffect(() => {
        localStorage.setItem('Selling_items_SortType', '');
        localStorage.setItem('Reccomendation_SortType', '');
        if(leftFilter.value!=='Custom' || (leftFilter.value==='Custom' && leftCustomDate[0] && leftCustomDate[1]) || refresh){
        
          dispatch(      
            getKIPWidgetData({
              leftFilter: leftFilter.value==='Custom'?{from:convertDateFormate(leftCustomDate[0]),to:convertDateFormate(leftCustomDate[1])}:getDateByName(leftFilter.value),
              rightFilter: rightFilter.value==='Custom'?{from:convertDateFormate(comparisonDate[0]),to:convertDateFormate(comparisonDate[1])}:getDateByName(rightFilter.value),  
              mealPeriod: mealPeriod,
              recalculate: refresh,
            })
          );
        }
    }, [leftFilter,leftCustomDate, rightFilter, mealPeriod,comparisonDate, refresh,  dispatch]);
    //console.log(widgetData);
    const ecomWidgets = [
        {
            id: 1,
            label: "Location Covers",
            counter: !widgetAjax ? widgetData.covers:'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_cover_percent).toFixed(2)) :'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_cover_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 2,
            label: "Location Average Check",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.average_check, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_avg_check_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_avg_check_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_avg_check_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 3,
            label: "Location Revenue",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.revenue, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_rev_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_rev_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_rev_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 4,
            label: "Table Occupancy",
            counter: !widgetAjax ? widgetData?.table_occupancy+"%":'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_table_occupancy_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_table_occupancy_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_table_occupancy).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 5,
            label: "Seat Occupancy",
            counter: !widgetAjax ? widgetData?.seat_occupancy+"%":'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_seat_occupancy_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_seat_occupancy_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_seat_occupancy_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_seat_occupancy_percent && Number(widgetData?.ly_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 6,
            label: "RevPASH",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData?.revpash, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_revpash_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_revpash_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_revpash_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
    ];

    const ecomWidgetsRestaurant1 = [
        {
            id: 1,
            label: "Covers",
            counter: !widgetAjax ? widgetData.covers:'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_cover_percent).toFixed(2)) :'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_cover_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 2,
            label: "Average Check",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.average_check, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_avg_check_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_avg_check_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_avg_check_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 3,
            label: "Revenue",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.revenue, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_rev_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_rev_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_rev_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 4,
            label: "Table Occupancy",
            counter: !widgetAjax ? widgetData?.table_occupancy+"%":'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_table_occupancy_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_table_occupancy_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_table_occupancy).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 5,
            label: "Seat Occupancy",
            counter: !widgetAjax ? widgetData?.seat_occupancy+"%":'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_seat_occupancy_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_seat_occupancy_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_seat_occupancy_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_seat_occupancy_percent && Number(widgetData?.ly_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 6,
            label: "RevPASH",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData?.revpash, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_revpash_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_revpash_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_revpash_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
    ];

    const ecomWidgetsLocationDetails = [
        {
            id: 1,
            label: "Covers",
            counter: !widgetAjax ? widgetData.covers:'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_cover_percent).toFixed(2)) :'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_cover_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 2,
            label: "Average Check",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.average_check, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_avg_check_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_avg_check_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_avg_check_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 6,
            label: "RevPASH",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData?.revpash, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_revpash_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_revpash_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_revpash_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 4,
            label: "Table Occupancy",
            counter: !widgetAjax ? widgetData?.table_occupancy+"%":'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_table_occupancy_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_table_occupancy_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_table_occupancy).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 5,
            label: "Seat Occupancy",
            counter: !widgetAjax ? widgetData?.seat_occupancy+"%":'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_seat_occupancy_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_seat_occupancy_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_seat_occupancy_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_seat_occupancy_percent && Number(widgetData?.ly_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
        {
            id: 3,
            label: "Revenue",
            counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.revenue, currency):'',
            lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_rev_percent).toFixed(2)):'',
            budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_rev_percent).toFixed(2)):'',
            fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_rev_percent).toFixed(2)):'',
            decimals: 0,
            prefix: "",
            suffix: "",
            separator: "",
            lybgClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            budbgClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            fcbgClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
            lyArrowClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            budArrowClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            fcArrowClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
        },
    ];
   
    return (
        <>
        <Row id="LocationWidget">
            <Card>
                <CardHeader className="ps-0 border-0 align-items-center d-flex">
                    <div
                        onClick={() => setShowFull(prev => !prev)}
                        className="arrow-toggle me-2"
                    >
                        <i className={`ri-arrow-${showFull ? "down" : "right"}-s-line fs-4`}></i>
                    </div>

                    <h4 className="card-title mb-0 flex-grow-1">Downtown District</h4>     
                    <div className="d-flex gap-1">
                        <Button color="secondary" outline onClick={()=> {
                            setSelectedSection("Downtown District");
                            toggleLocationDetails(true);
                        }}>View Location Details</Button>                     
                    </div>               
                </CardHeader>
                <CardBody className="p-0">
                {!showFull ? (
                <Row id="overallLess">
                    {ecomWidgets.slice(0, 3).map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="card-animate">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                ) : (
                <Row id="overallFull">
                    {ecomWidgets.map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="card-animate">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}

                    <Row>
                        <Card style={{ marginBottom: "10px", boxShadow: "0 1px 2px rgba(56, 65, 74, 0.15)", marginLeft: "10px" }}>
                            <CardHeader className="ps-0 border-0 align-items-center d-flex">
                                <h4 className="card-title mb-0 flex-grow-1">Downtown Restaurant</h4>  
                                <div className="d-flex gap-1">
                                    <Button color="secondary" outline onClick={()=> {
                                        setSelectedSection("Downtown Restaurant");
                                        toggleLocationDetails(true);
                                    }}>View Details</Button>                     
                                </div>                   
                            </CardHeader>
                            <CardBody className="p-0">
                                <Row>
                                {ecomWidgetsRestaurant1.map((item, key) => (
                                    <Col xl={4} key={key}>
                                        <Card className="card-animate">
                                            <CardBody>
                                                <div className="d-flex align-items-center">                            
                                                    <div className="flex-grow-1 overflow-hidden">
                                                        <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                                        <div className="d-flex align-items-center mb-3">
                                                            <h4 className="fs-4 flex-grow-1 mb-0">
                                                                <span className="counter-value me-1">
                                                                
                                                                    {item?.counter}
                                                                </span>
                                                            </h4>
                                                            
                                                        </div>
                                                        <div className="d-flex flex-wrap justify-content-between">
                                                            <p className="text-muted mb-0">
                                                                <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                            </p>
                                                            
                                                            <p className="text-muted mb-0">
                                                                <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                            </p>
                                                            
                                                            <p className="text-muted mb-0">
                                                                <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>


                    <Row>
                        <Card style={{ marginBottom: "10px", boxShadow: "0 1px 2px rgba(56, 65, 74, 0.15)", marginLeft: "10px" }}>
                            <CardHeader className="ps-0 border-0 align-items-center d-flex">
                                <h4 className="card-title mb-0 flex-grow-1">Downtown Cafe</h4>  
                                <div className="d-flex gap-1">
                                    <Button color="secondary" outline onClick={()=> {
                                        setSelectedSection("Downtown Cafe");
                                        toggleLocationDetails(true);
                                    }}>View Details</Button>                     
                                </div>                  
                            </CardHeader>
                            <CardBody className="p-0">
                                <Row>
                                {ecomWidgetsRestaurant1.map((item, key) => (
                                    <Col xl={4} key={key}>
                                        <Card className="card-animate">
                                            <CardBody>
                                                <div className="d-flex align-items-center">                            
                                                    <div className="flex-grow-1 overflow-hidden">
                                                        <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                                        <div className="d-flex align-items-center mb-3">
                                                            <h4 className="fs-4 flex-grow-1 mb-0">
                                                                <span className="counter-value me-1">
                                                                
                                                                    {item?.counter}
                                                                </span>
                                                            </h4>
                                                            
                                                        </div>
                                                        <div className="d-flex flex-wrap justify-content-between">
                                                            <p className="text-muted mb-0">
                                                                <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                            </p>
                                                            
                                                            <p className="text-muted mb-0">
                                                                <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                            </p>
                                                            
                                                            <p className="text-muted mb-0">
                                                                <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                </Row>
                )}
                </CardBody>
            </Card>

            {/* Location detail popup */}
            <Modal isOpen={isLocationDetailOpen} toggle={toggleLocationDetails} size="xl">
                <ModalHeader toggle={toggleLocationDetails}>{selectedSection} - Performance Details ({leftFilter?.label})</ModalHeader>
                <ModalBody>
                    <Row>
                    {ecomWidgetsLocationDetails.slice(0, 3).map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="card-animate">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                    <Row>
                        <Card className="p-2">
                        <CardHeader className="border-0 align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Daily Performance Trends - Covers & Metrics</h4>                    
                        </CardHeader>
                        <CardBody>
                            <LocationChartCovers />
                        </CardBody>
                        </Card>
                    </Row>
                    <Row>
                    {ecomWidgetsLocationDetails.slice(3, 6).map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="card-animate">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                    <Row>
                        <Card className="p-2">
                        <CardHeader className="border-0 align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Daily Performance Trends - Revenue & Occupancy</h4>                    
                        </CardHeader>
                        <CardBody>
                            <LocationChartRevenue />
                        </CardBody>
                        </Card>
                    </Row>
                </ModalBody>
                {/* <ModalFooter>
                    <Button color="secondary" onClick={toggleLocationDetails}>Close</Button>
                </ModalFooter> */}
            </Modal>
            {/* {showFull &&
                <Card >
                        <CardHeader className="ps-0 border-0 align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Downtown Restaurant</h4>                    
                        </CardHeader>
                        <CardBody className="p-0">
                            <Row>
                            {ecomWidgets.map((item, key) => (
                                <Col xl={4} key={key}>
                                    <Card className="card-animate">
                                        <CardBody>
                                            <div className="d-flex align-items-center">                            
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                                    <div className="d-flex align-items-center mb-3">
                                                        <h4 className="fs-4 flex-grow-1 mb-0">
                                                            <span className="counter-value me-1">
                                                                
                                                                {item?.counter}
                                                            </span>
                                                        </h4>
                                                        
                                                    </div>
                                                    <div className="d-flex flex-wrap justify-content-between">
                                                        <p className="text-muted mb-0">
                                                            <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                        </p>
                                                        
                                                        <p className="text-muted mb-0">
                                                            <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                        </p>
                                                        
                                                        <p className="text-muted mb-0">
                                                            <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                            </Row>
                        </CardBody>
                </Card>
            }             */}
        </Row>
        </>
    );
};

export default LocationWidget;
